// eslint-disable-next-line @typescript-eslint/no-var-requires
const version = require('./version.js');
const versionFile = '/version.txt';
export class VersionCheck {
    static downloadTextFile(url) {
        return new Promise(function (resolve, reject) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url += (url.match(/\?/) == null ? '?' : '&') + (new Date()).getTime(), false);
            // xhr.responseType = 'text';
            xhr.onload = function () {
                if (this.status >= 200 && this.status < 300) {
                    resolve(xhr.responseText);
                }
                else {
                    reject(new Error(`status: ${this.status}, statusText: ${xhr.statusText}`));
                }
            };
            xhr.onerror = function () {
                reject(new Error(`status: ${this.status}, statusText: ${xhr.statusText}`));
            };
            xhr.send();
        });
    }
    static async requiresVersionUpdate() {
        if (VersionCheck.versionUpdateRequired)
            return false;
        // do not check for version update if less than 10 minutes since the last check
        if (VersionCheck.versionCheckTime != null && VersionCheck.versionCheckTime + 10 * 60 * 1000 > new Date().getTime())
            return false;
        VersionCheck.versionCheckTime = new Date().getTime();
        try {
            VersionCheck.serverVer = await VersionCheck.downloadTextFile(versionFile);
            VersionCheck.clientVer = `${version}`;
            VersionCheck.versionUpdateRequired = VersionCheck.serverVer != VersionCheck.clientVer;
            return VersionCheck.versionUpdateRequired;
        }
        catch (e) {
            console.log(e);
        }
        return false;
    }
}
VersionCheck.versionUpdateRequired = false;
VersionCheck.serverVer = '';
VersionCheck.clientVer = '';
